<template>
  <div id="baseapp">
    <!-- <router-view/> -->
  </div>
</template>

<script>
import PeticionForm from '@/components/PeticionForm'

export default {
  name: 'App',
  components: {PeticionForm}
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue